module.exports = __webpack_public_path__ + "7cf5cab88fe729665e9d27712fc395e1.svg";